import React from 'react';
// @ts-ignore
import { Line } from 'react-chartjs-2';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
// @ts-ignore
import 'chart.js/auto'; // ADD THIS
import { View } from 'react-native';
import { SubmissionStat, VoteStat } from '../../types/global/helper';

export interface ILineChartSubmissionData {
    voteStat?: VoteStat[];
    submissionStat?: SubmissionStat[];
    trendSelector?: 'vote' | 'submission';
}

const LineChart: React.FC<ILineChartSubmissionData> = ({ voteStat, trendSelector, submissionStat }) => {
    const voteDates = voteStat && voteStat.map(data => data._id);
    const voteRates = voteStat && voteStat.map(data => data.vote_rate);
    const submissionDates = submissionStat && submissionStat.map(data => data._id);
    const submissionRates = submissionStat && submissionStat.map(data => data.submission_rate);

    const { themeStyle } = useThemeContext();

    // Configuring the chart data
    const chartData = {
        labels: trendSelector === 'vote' ? voteDates : submissionDates,
        datasets: [
            {
                label: 'Submission Rate',
                data: trendSelector === 'vote' ? voteRates : submissionRates,
                fill: false,
                borderColor: theme[themeStyle].highlight,
                lineTension: 0.1,
            },
        ],
    };

    const chartOptions = {
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                grid: {
                    color: theme[themeStyle].fillDarkGrey, // Background lines color
                    display: true,
                    drawBorder: true,
                    tickLength: 0.1,
                    borderDash: [20, 20],
                },
                ticks: {
                    maxTicksLimit: 10, // Increase the number of y-axis ticks
                    padding: 10,
                },
                border: { dash: [3, 3] },
            },
            x: {
                grid: {
                    color: theme[themeStyle].fillDarkGrey, // Background lines color
                    display: true,
                    drawBorder: true,
                    tickLength: 0.1,
                    borderDash: [20, 20],
                },
                ticks: {
                    maxTicksLimit: 10, // Increase the number of x-axis ticks
                    padding: 10,
                },
                border: { dash: [3, 3] },
            },
        },
        plugins: {
            title: {
                display: false,
                text: 'Contest Submission Rate',
                color: theme[themeStyle].lightWhite, // Title color
            },
            legend: {
                display: false,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 20,
            },
        },
        elements: {
            point: {
                radius: 5, // Disable point markers
            },
        },
        backgroundColor: theme[themeStyle].primary_background, // Background color of the chart
    };

    return (
        <View style={{ flex: 1, maxHeight: 400 }}>
            <Line data={chartData} options={chartOptions} draggable={false} />
        </View>
    );
};

export { LineChart };
